export const GET_EMPLOYEES = gql`
  query getEmployees($filters: EmployeeFiltersInput, $pageInfo: PageInfoInput) {
    employees(filters: $filters, pageInfo: $pageInfo) {
      items {
        employeeId
        firstName
        lastName
        jobTitle
        email
        phone
        roleType
        emailConnected
        status
        coverImage
        calendarConnected
        mfaEnabled
        company {
          companyName
        }
      }
      pageInfo {
        offset
        limit
      }
      totalCount
    }
  }
`

export const GET_EMPLOYEES_ONLY = gql`
  query getEmployeesOnly(
    $filters: EmployeeFiltersInput
    $pageInfo: PageInfoInput
  ) {
    employees(filters: $filters, pageInfo: $pageInfo) {
      items {
        employeeId
        firstName
        lastName
        jobTitle
        email
        phone
        roleType
        status
        coverImage
        calendarConnected
      }
      pageInfo {
        offset
        limit
      }
      totalCount
    }
  }
`

export const GET_EMPLOYEE_BY_ID = gql`
  query getEmployeeById($id: String!) {
    employee(id: $id) {
      employeeId
      firstName
      lastName
      email
      phone
      emailConnected
      calendarConnected
      calendarEventId
      calendarTimezone
      calendarAPIKeySet
      jobTitle
      roleType
      mfaEnabled
    }
  }
`

export const DELETE_EMPLOYEE = gql`
  mutation deleteEmployee($id: String!) {
    deleteEmployee(id: $id) {
      employeeId
    }
  }
`

export const CREATE_EMPLOYEE = gql`
  mutation createEmployee($input: CreateEmployeeInput!) {
    createEmployee(input: $input) {
      employeeId
    }
  }
`

export const UPDATE_EMPLOYEE = gql`
  mutation updateEmployee($id: String!, $input: UpdateEmployeeInput!) {
    updateEmployee(id: $id, input: $input) {
      employeeId
    }
  }
`

export const CONFIGURE_EMPLOYEE_CALENDAR = gql`
  mutation configureEmployeeCalendar($id: String!, $calendarAPIKey: String!) {
    configureEmployeeCalendar(id: $id, calendarAPIKey: $calendarAPIKey) {
      employeeId
    }
  }
`

export const EMPLOYEE_REMOVAL_PREVIEW = gql`
  query employeeRemovalPreview($employeeId: String!) {
    employeeRemovalPreview(employeeId: $employeeId) {
      employeeId
      employeeName
      leadApplicantCount
      memberApplicantCount
      openTaskCount
      voeEmailCount
      voeAssignmentCount
      packageOrderCount
      adverseActionCaseCount
      jobListingCount
      jobListingRoundRobinCount
      trackingLinkRoundRobinCount
      unreadNotificationCount
      activePermissionCount
    }
  }
`

export const REMOVE_EMPLOYEE = gql`
  mutation removeEmployee($input: RemoveEmployeeInput!) {
    removeEmployee(input: $input) {
      success
      removedEmployeeId
      reassignedToEmployeeId
    }
  }
`
